/**
 * SCORM 2004 content type — schema, types, defaults.
 * Independent from ACH content-core.
 */

export interface Scorm2004Data {
    /** Content title (auto-filled from manifest, user-editable). */
    title?: string;
    /** Content description. */
    description?: string;
    /** SCORM version detected from manifest. */
    scormVersion?: string;
    /** SCORM package ID (set after upload). */
    packageId?: string;
    /** Original zip filename. */
    packageFileName?: string;
    /** File size in bytes. */
    packageFileSize?: number;
    /** Package base URL for file serving. */
    packageUrl?: string;
    /** Launch URL relative to packageUrl. */
    launchUrl?: string;
    /** Parsed manifest data. */
    manifest?: Record<string, unknown>;
    /** Default organization ID. */
    defaultOrganizationId?: string;
}

export type Scorm2004Answer = {
    completed: boolean;
    scoreRaw?: number | null;
    scoreScaled?: number | null;
    completionStatus?: string;
    successStatus?: string;
    totalTime?: string;
};

export const defaultScorm2004Data: Scorm2004Data = {
    title: undefined,
    description: undefined,
    scormVersion: undefined,
    packageId: undefined,
    packageFileName: undefined,
    packageFileSize: undefined,
    packageUrl: undefined,
    launchUrl: undefined,
    manifest: undefined,
    defaultOrganizationId: undefined,
};
